import type { IconNames } from '@dixa/lib-shared-habla';
import { boundMethod } from 'autobind-decorator';
import { ReactElement } from 'react';
import { v4 as uuid } from 'uuid';

import { FlowNodeTypes } from 'components/powerFlowShared/components/types';
import { SafeInnerHtmlSetter } from 'components/shared/util/SafeInnerHtmlSetter';
import {
  FlowNode,
  flowNodeColor,
  InternalPortT,
  NodeT,
  NodeTypeComponent,
  RegisterPortT,
} from 'fable/flowEditor';

import { formatPortsHelper } from '../../../powerFlowShared/helpers/nodePortFormatter';
import { PowerChatFlowExtraDataT } from '../PowerChatFlow';
import ActionModal from '../modals/chatinput';

export type FlowChatNodeChatInputPayloadT = {
  field_label: string;
  field_placeholder: string;
  message: string;
  nextNodeId: string;
};

export type FlowChatNodeChatInputTypeT = FlowNodeTypes.CHAT_INPUT;
export type FlowChatNodeChatInputT = NodeT<
  FlowChatNodeChatInputTypeT,
  FlowChatNodeChatInputPayloadT
>;

const portTranslator = (node: FlowChatNodeChatInputT): RegisterPortT[] => {
  return [
    {
      id: uuid(),
      type: 'out',
      label: 'arrow',
      connection: node.payload.nextNodeId,
    },
  ];
};

export class ChatinputNode extends NodeTypeComponent<
  FlowChatNodeChatInputT,
  PowerChatFlowExtraDataT
>() {
  static icon: IconNames = 'input';
  static label = 'Chat input';
  static color = flowNodeColor.orange;
  static height = FlowNode.dimensions.h + 16;
  static translatePayload = formatPortsHelper(portTranslator);
  static ActionModal = ActionModal;
  static actionTrigger = { type: FlowNodeTypes.CHAT_INPUT };
  static updateConnection = (
    node: FlowChatNodeChatInputT,
    _port: InternalPortT,
    newConnection: string,
  ): FlowChatNodeChatInputT => {
    const payload: FlowChatNodeChatInputPayloadT = { ...node.payload };
    payload.nextNodeId = newConnection;

    return { ...node, payload };
  };

  @boundMethod
  triggerEdit() {
    const { onEdit, node } = this.props;
    onEdit(node, node.nodeType);
  }

  _renderText(): ReactElement {
    const {
      node: {
        payload: { message },
      },
    } = this.props;

    return (
      <div
        style={{
          fontStyle: 'normal',
          height: '32px',
          overflow: 'hidden',
        }}
      >
        <SafeInnerHtmlSetter
          element="div"
          // message was created by the FieldEditor it has to be injected as html
          content={message}
        />
      </div>
    );
  }

  render() {
    return (
      <FlowNode
        color={flowNodeColor.orange}
        icon={ChatinputNode.icon}
        label={ChatinputNode.label}
        text={this._renderText()}
        onEdit={this.triggerEdit}
      />
    );
  }
}
